import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  capReached: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.capReached',
    defaultMessage:
      'Showing the first {total, number} applicants. Narrow your filters to review more.',
    description:
      'The resume review list is capped; total is the number of applicants loaded (the displayed cap). Filters can narrow the list to reach other applicants',
  },
  unavailable: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.unavailable',
    defaultMessage: 'Applicant no longer available',
    description:
      'Applicant deleted, merged, or no longer accessible to the recruiter',
  },
  unavailableDescription: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.unavailableDescription',
    defaultMessage:
      'This applicant was deleted or merged, or you no longer have access. Use Prev or Next to keep reviewing.',
    description:
      'Explains why a review list applicant cannot be shown and how to continue',
  },
  failed: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.failed',
    defaultMessage: 'Applicant failed to load',
    description:
      'Temporary failure loading an applicant profile, not a deleted applicant',
  },
  failedDescription: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.failedDescription',
    defaultMessage:
      'Exit full page and open this applicant again, or use Prev or Next to keep reviewing.',
    description: 'Recovery actions after an applicant profile request fails',
  },
  position: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.position',
    defaultMessage:
      '{position, number} of {total, number}{truncated, select, true {+} other {}}',
    description: 'Applicant position within the fixed resume review list',
  },
  universalApplicantView: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.universalApplicantView',
    defaultMessage: 'Universal Applicant View',
    description: 'Name of the applicant list across openings',
  },
});
